import { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalState';
import { listenMoodsChange } from '../../services/teamMoods';

function useListenMoodsChange() {
  const { currentRetrospectiveId, onUpdateMoods } = useContext(GlobalContext);

  useEffect(() => {
    const unsubscribe = listenMoodsChange(
      currentRetrospectiveId,
      (querySnapshot) => {
        const moods = [];
        for (const document_ of querySnapshot.docs) {
          moods.push({ id: document_.id, ...document_.data() });
        }
        onUpdateMoods(moods);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [currentRetrospectiveId, onUpdateMoods]);
}

export default useListenMoodsChange;
